/**
 * Remove the client-injected "[Context: user is on …]" line from a stored
 * user message. The line is written for the MODEL; the widget matches
 * restored history rows to its optimistic local copies by exact text, so the
 * prefix must never survive into the message list.
 */
export function stripPageContextPrefix(text: string): string {
  return text.replace(/^\[Context:[^\n]*\]\s*/u, '');
}
